import { gql } from '@apollo/client'

export default gql(`
    mutation createOrUpdateIpWhitelistingItem( $input: [CreateOrUpdateIpWhitelistingItemInput] ) {
        createOrUpdateIpWhitelistingItem(
            input: $input
        ) {
            ip
        }
    }`
)
